export default {
  path: 'user_stat',
  name: 'UserStat',
  component: () => import('@/pages/user/monitor/UserMonitor.vue'),
  meta: { title: '用户监控' },
}
